<div class="container-fluid service-bg from-top-pad">
    <!-- Titles -->
    <div class="row">
        <div class="col-md-12">
            <h1>
                {{'gen_my_account' | translate}}
            </h1>
        </div>
    </div>

    <!-- Information -->
    <div *ngIf="subscriber">
        <!-- Email -->
        <div class="row">
            <div class="col-6 col-md-3 pl-5">
                <p>
                    {{'gen_email' | translate}}: {{subscriber.email}}
                </p>
            </div>
            <div class="col-6 col-md-3">
                <a href="#/account/changeEmail">{{'account_change_email' | translate}}</a>
            </div>
        </div>

        <!-- Password -->
        <div class="row">
            <div class="col-6 col-md-3 pl-5">
                <p>
                    {{'gen_password' | translate}}: ******
                </p>
            </div>
            <div class="col-6 col-md-3">
                <a href="#/account/changePassword">{{'gen_change_pwd' | translate}}</a>
            </div>
        </div>

        <hr>
        <!-- Billing History -->
        <div class="row">
            <div class="col-md-12 pl-5">
                <a href="#/account/mySubscription">{{'gen_my_subscription' | translate}}</a>
            </div>
            <div class="col-md-12 pl-5">
                <a href="#/account/billingHistory">{{'gen_billing_history' | translate}}</a>
            </div>
            <div class="col-md-12 pl-5">
                <a href="#/account/editInfo">{{'gen_subscriber_info' | translate}}</a>
            </div>
            <div class="col-md-12 pl-5">
                <a href="#/account/activateCoupon">{{'gen_activate_coupon' | translate}}</a>
            </div>
        </div>
    </div>
</div>